import { CheckboxGroup, Divider, FormCheckbox } from 'omakase';
import { SearchFiltersFieldNames } from 'components/www/availability-search/SearchHeader';
import { consumer } from '@tock/coretypes';
import {
  dividers,
  fieldset,
} from 'components/www/availability-search/filters/searchFiltersCssDefs';
import { keys, uniq } from 'es-toolkit/compat';

export interface ExperienceTags {
  experienceTagAll: string[];
  experienceTagToGo: string[];
  experienceTagDineIn: string[];
  experienceTagSeatingArea: string[];
  experienceTagCampaign: string[];
}

interface Props {
  aggregationsInternal?: consumer.Aggregations;
  selectedTags: ExperienceTags;
}

const SearchFilterExperienceTags: React.FunctionComponent<Props> = ({
  aggregationsInternal,
  selectedTags,
}) => {
  if (!aggregationsInternal) {
    return null;
  }

  const {
    experienceTagAllAggregation,
    experienceTagDineInAggregation,
    experienceTagTogoAggregation,
    experienceTagCampaignAggregation,
  } = aggregationsInternal;

  const aggregationOptionsToCheckboxes = (options: string[], name: string) => {
    return options.map((experienceTagOption) => {
      return (
        <FormCheckbox
          key={`${experienceTagOption}`}
          id={experienceTagOption}
          label={experienceTagOption}
          value={experienceTagOption}
          weight="book"
          name={name}
          size="large"
        />
      );
    });
  };

  const tagAllOptions = uniq([
    ...keys(experienceTagAllAggregation?.termToCount),
    ...selectedTags.experienceTagAll,
  ]);

  const tagDineInOptions = uniq([
    ...keys(experienceTagDineInAggregation?.termToCount),
    ...selectedTags.experienceTagDineIn,
  ]);

  const tagToGoOptions = uniq([
    ...keys(experienceTagTogoAggregation?.termToCount),
    ...selectedTags.experienceTagToGo,
  ]);

  const tagCampaignOptions = uniq([
    ...keys(experienceTagCampaignAggregation?.termToCount),
    ...selectedTags.experienceTagCampaign,
  ]);

  const checkboxElements = [
    ...aggregationOptionsToCheckboxes(
      tagCampaignOptions,
      SearchFiltersFieldNames.experienceTagCampaign
    ),
    ...aggregationOptionsToCheckboxes(tagAllOptions, SearchFiltersFieldNames.experienceTagAll),
    ...aggregationOptionsToCheckboxes(
      tagDineInOptions,
      SearchFiltersFieldNames.experienceTagDineIn
    ),
    ...aggregationOptionsToCheckboxes(tagToGoOptions, SearchFiltersFieldNames.experienceTagToGo),
  ];

  return (
    <>
      {checkboxElements.length > 0 && (
        <>
          <Divider css={dividers} position="middle" tall />
          <CheckboxGroup css={fieldset} disclosureMode="static" label="Unique experiences">
            {checkboxElements}
          </CheckboxGroup>
        </>
      )}
    </>
  );
};

export default SearchFilterExperienceTags;
